export default "__VITE_ASSET__BVcwT6v6__"